import { useMutation } from 'react-query';
import {
  updateReadingProgress,
  type UpdateReadingProgressBody,
  type UpdateReadingProgressResponse
} from '../../services/sceneService';

export const useUpdateReadingProgress = () => {
  return useMutation<
    UpdateReadingProgressResponse,
    Error,
    { sceneId: string; body: UpdateReadingProgressBody }
  >({
    mutationFn: ({ sceneId, body }) => updateReadingProgress({ sceneId, body })
  });
};
